var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"black","text":"","width":"100%","title":"Show PK-DB data for example study","to":"/data/PKDB00057/"}},[_c('v-icon',{attrs:{"left":"","color":"#1E90FF"}},[_vm._v(_vm._s(_vm.faIcon('data')))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }